(function () {
  const EMBROIDERY_LOCK = new WeakMap();

  function getQtyFromForm(form) {
    const qtyInput = form.querySelector('input[name="quantity"]');
    const qty = qtyInput ? parseInt(qtyInput.value || "1", 10) : 1;
    return Number.isFinite(qty) && qty > 0 ? qty : 1;
  }

  function getMainVariantIdFromForm(form) {
    const idInput = form.querySelector('input[name="id"]');
    return idInput ? idInput.value : null;
  }

  // ✅ Find upsell even if it's not inside the form
  function findUpsellRootNear(el) {
    if (!el) return null;

    // 1) inside the same form
    const form = el.closest('form');
    if (form) {
      const inside = form.querySelector('.embroidery-upsell');
      if (inside) return inside;
    }

    // 2) within the product summary / main product section
    const scope =
      el.closest('.product-summary') ||
      el.closest('[data-section-type="main-product"]') ||
      el.closest('.shopify-section') ||
      document;

    return scope.querySelector('.embroidery-upsell');
  }

  function isEmbroideryEnabled(root) {
    const cb = root?.querySelector('[data-embroidery-enabled]');
    return !!(cb && cb.checked);
  }

  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error(await res.text().catch(() => 'Add failed'));
    return res.json();
  }

  function rehydrateCartDrawerImages(drawerEl) {
    if (!drawerEl) return;

    const toWidthUrl = (url, width) => {
      if (!url) return url;

      const parts = url.split('?');
      const base = parts[0]
        .replace(/_(\d+)x(\d+)?(?=\.)/g, '')
        .replace(/_(small|compact|medium|large|grande)(?=\.)/g, '');
      const qs = parts[1] ? `?${parts[1]}` : '';

      const cleanQs = qs
        ? qs.replace(/([?&])width=\d+/g, '$1').replace(/[?&]$/, '')
        : '';

      const finalJoiner = cleanQs ? '&' : '?';
      return `${base}${cleanQs}${finalJoiner}width=${width}`;
    };

    const upgradeImg = (img) => {
      const ds = img.dataset || {};
      let src = ds.src || img.getAttribute('src') || '';
      let srcset = ds.srcset || img.getAttribute('srcset') || '';

      if (!srcset || srcset.trim().length < 10) {
        const w1 = 240;
        const w2 = 480;
        const u1 = toWidthUrl(src, w1);
        const u2 = toWidthUrl(src, w2);
        src = u1;
        srcset = `${u1} ${w1}w, ${u2} ${w2}w`;
      } else {
        src = toWidthUrl(src, 240);
      }

      img.setAttribute('src', src);
      img.setAttribute('srcset', srcset);

      if (ds.sizes) img.setAttribute('sizes', ds.sizes);

      img.setAttribute('loading', 'eager');
      img.setAttribute('fetchpriority', 'high');
      img.decoding = 'async';

      img.classList.remove('lazyload', 'lazyloaded', 'is-loading');
    };

    drawerEl.querySelectorAll('picture source').forEach((source) => {
      const ds = source.dataset || {};
      const srcset = ds.srcset || source.getAttribute('srcset');
      if (srcset) source.setAttribute('srcset', srcset);
    });

    drawerEl.querySelectorAll('img').forEach(upgradeImg);

    try {
      if (typeof window.lazyloading === 'function') {
        drawerEl.querySelectorAll('.lazy-loading-image').forEach(el => window.lazyloading(el));
      }
    } catch (e) {}
  }

  async function refreshCartDrawer() {
    try {
      const res = await fetch(`/?sections=cart-drawer&_=${Date.now()}`, {
        credentials: 'same-origin',
        cache: 'no-store'
      });
      if (!res.ok) return false;

      const sections = await res.json();
      const html = sections && sections['cart-drawer'];
      if (!html) return false;

      const doc = new DOMParser().parseFromString(html, 'text/html');

      const freshDrawer = doc.querySelector('cart-drawer');
      const currentDrawer = document.querySelector('cart-drawer');

      if (freshDrawer && currentDrawer) {
        currentDrawer.replaceWith(freshDrawer);
        rehydrateCartDrawerImages(freshDrawer);
      } else {
        return false;
      }

      const cartRes = await fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (cartRes.ok) {
        const cart = await cartRes.json();
        document.querySelectorAll('.cart-count').forEach(el => (el.textContent = cart.item_count));
      }

      return true;
    } catch (e) {
      console.error('[embroidery] refreshCartDrawer failed:', e);
      return false;
    }
  }

  function openCartDrawer() {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.open === 'function') return drawer.open();
    document.querySelector('.section-header-cart-drawer-toggle')?.click();
  }

  // =========================
  // Bundle helpers (FIXED)
  // =========================

  function isBundleMode(root) {
    return !!root?.querySelector('[data-embroidery-bundle-item]');
  }

  function readBundleEntries(root) {
    const blocks = root.querySelectorAll('[data-embroidery-bundle-item]');
    if (!blocks || !blocks.length) return [];

    const entries = [];
    blocks.forEach((block) => {
      const label = (block.getAttribute('data-bundle-label') || '').trim();
      if (!label) return;

      const initials = (block.querySelector('[data-embroidery-bundle-text]')?.value || '')
        .trim()
        .slice(0, 6)
        .toUpperCase();

      const color =
        (block.querySelector('[data-embroidery-bundle-color]')?.value || '').trim() || '—';

      // ✅ IMPORTANTE:
      // - Guardamos todos (para poder validar "faltan iniciales" si quieres).
      entries.push({ label, initials, color });
    });

    return entries;
  }

  async function handleEmbroideryAdd(form, root) {
    if (EMBROIDERY_LOCK.get(form)) return;
    EMBROIDERY_LOCK.set(form, true);

    // ✅ Extra guard: evita doble ejecución click+submit del theme
    if (root.__embroideryBusy) return;
    root.__embroideryBusy = true;

    try {
      const mainVariantId = getMainVariantIdFromForm(form);
      const qty = getQtyFromForm(form);
      const embroideryVariantId = root?.getAttribute('data-embroidery-variant-id');

      if (!mainVariantId || !embroideryVariantId) return;

      const bundleMode = isBundleMode(root);

      // =========================
      // Bundle mode (FIXED)
      // =========================
      if (bundleMode) {
        const bundleEntries = readBundleEntries(root);

        // Si por lo que sea hay UI bundle pero lista vacía, no hacemos nada raro
        if (!bundleEntries.length) return;

        // ¿Hay al menos una inicial escrita?
        const anyFilled = bundleEntries.some(e => !!e.initials);

        // Si no han escrito nada → no añadir bordado
        if (!anyFilled) return;

        // ✅ Estricto: exige iniciales en TODOS los bloques
        const missing = bundleEntries.some(e => !e.initials);
        if (missing) {
          // Puedes mostrar un error UI aquí si quieres
          return;
        }

        const items = [{ id: Number(mainVariantId), quantity: qty }];

        bundleEntries.forEach((entry) => {
          items.push({
            id: Number(embroideryVariantId),
            quantity: qty,
            properties: {
              'Pieza': entry.label,
              'Iniciales': entry.initials,
              'Color': entry.color
            }
          });
        });

        await addItems(items);
        await refreshCartDrawer();
        openCartDrawer();
        return; // ✅ IMPORTANTÍSIMO: no caer al modo single
      }

      // =========================
      // Single-product mode
      // =========================
      const initials = (root.querySelector('[data-embroidery-text]')?.value || '')
        .trim()
        .slice(0, 6)
        .toUpperCase();

      const color = (root.querySelector('[data-embroidery-color]')?.value || '').trim() || '—';

      if (!initials) return;

      const items = [
        { id: Number(mainVariantId), quantity: qty },
        {
          id: Number(embroideryVariantId),
          quantity: qty,
          properties: { 'Iniciales': initials, 'Color': color }
        }
      ];

      await addItems(items);
      await refreshCartDrawer();
      openCartDrawer();
    } catch (err) {
      console.error('[embroidery] add failed', err);
    } finally {
      setTimeout(() => {
        EMBROIDERY_LOCK.set(form, false);
        root.__embroideryBusy = false;
      }, 400);
    }
  }

  function onSubmit(e) {
    const form = e.target;
    if (!(form instanceof HTMLFormElement)) return;

    const hasVariant = !!form.querySelector('input[name="id"]');
    if (!hasVariant) return;

    const root = findUpsellRootNear(form);
    if (!root) return;
    if (!isEmbroideryEnabled(root)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    handleEmbroideryAdd(form, root);
  }

  function onClick(e) {
    const btn = e.target?.closest?.('button[name="add"], #AddToCart, [type="submit"][name="add"]');
    if (!btn) return;

    const form = btn.closest('form');
    if (!form) return;

    const hasVariant = !!form.querySelector('input[name="id"]');
    if (!hasVariant) return;

    const root = findUpsellRootNear(btn);
    if (!root) return;
    if (!isEmbroideryEnabled(root)) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation?.();

    handleEmbroideryAdd(form, root);
  }

  function init() {
    document.addEventListener('submit', onSubmit, true);
    document.addEventListener('click', onClick, true);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();